export const resolveEnvUrl = (currentHost: string, rawUrl: string): string => {
  try {
    const url = new URL(rawUrl)

    if (
      currentHost.includes('localhost') ||
      currentHost.includes('app.local') ||
      rawUrl.includes('localhost') ||
      rawUrl.includes('app.local') ||
      /^[0-9.]+$/.test(currentHost) ||
      /^[0-9.]+$/.test(rawUrl)
    ) {
      return rawUrl
    }

    const baseParts = url.hostname.split('.')
    const currentParts = currentHost.split('.')

    const subdomain =
      baseParts.length > 2 ? baseParts.slice(0, -2).join('.') : ''
    const newDomain = currentParts.slice(-2).join('.')

    const newHost = subdomain ? `${subdomain}.${newDomain}` : newDomain

    // Если pathname = "/", убираем его
    const path = url.pathname === '/' ? '' : url.pathname

    return `${url.protocol}//${newHost}${url.port ? `:${url.port}` : ''}${path}`
  } catch {
    return rawUrl
  }
}

export const resolveEnvUrlWithWindow = (rawUrl: string): string => {
  return resolveEnvUrl(window.location.host, rawUrl)
}
